import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { Building2, MapPin, Landmark, Star } from "lucide-react";

const KomikKatowice = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Katowice">
    <SeoSection title="Występy komediowe w Katowicach">
      <p>Katowice to serce Górnego Śląska i Zagłębia - regionu, który przeszedł spektakularną transformację z przemysłowego centrum w nowoczesny hub biznesowy i kulturalny. Oferujemy profesjonalne występy komediowe na terenie Katowic i całej aglomeracji śląskiej, obsługując eventy od kameralnych spotkań po wielkie gale korporacyjne.</p>
    </SeoSection>

    <SeoSection title="Eventy firmowe na Śląsku">
      <p>Aglomeracja śląska to jeden z największych rynków korporacyjnych w Polsce. Firmy z branży motoryzacyjnej, energetycznej, IT i usługowej regularnie organizują konferencje, spotkania integracyjne i gale. Nasi komicy potrafią nawiązać do śląskiej kultury i mentalności, tworząc autentyczny i angażujący występ dla lokalnej publiczności.</p>
    </SeoSection>

    <SeoSection title="Popularne lokalizacje eventowe w Katowicach">
      <SeoFeatureGrid features={[
        { icon: Landmark, title: "MCK", description: "Międzynarodowe Centrum Kongresowe - nowoczesna przestrzeń" },
        { icon: Star, title: "Spodek", description: "Ikona Katowic i kultowe miejsce eventowe" },
        { icon: Building2, title: "Strefa Kultury", description: "NOSPR, Muzeum Śląskie - unikalne lokalizacje" },
        { icon: MapPin, title: "Hotele premium", description: "Marriott, Angelo, Novotel i industrialne przestrzenie" },
      ]} />
    </SeoSection>

    <SeoSection title="Zamów komika w Katowicach">
      <p>Organizujesz event na Śląsku? Skontaktuj się z nami - obsługujemy całą aglomerację śląską, od Katowic po Gliwice, Sosnowiec, Bytom i Chorzów. Zaproponujemy format występu idealnie dopasowany do Twojego wydarzenia.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikKatowice;
